import module from 'finanzas/module.js'
import template from './template.html'

var Empleados_cache = {}

module.config(($dialogProvider) => {
  $dialogProvider.dialog('finanzas.detallesFacturacion.detalle.comisionistas.comisionista', {
    controller: 'FinanzasDetallesFacturacionDetalleComisionistasComisionistaController',
    template,
    controllerAs: '$ctrl',
  })
})

function FinanzasDetallesFacturacionDetalleComisionistasComisionistaController ($dialogParams, $kardex, dialog, $scope) {
  var $ctrl = this
  $ctrl.loading = false

  $ctrl.data = $dialogParams['commission'] || {
    ID_Empresa: undefined,
    ID_Empleado: undefined,
    ID_Nomina: undefined,
    Empresa: undefined,
    Empleado: undefined,
    Comision_Importe: 0,
    Comision_Porcentaje: '0.00',
    Total: 0,
  }

  $ctrl.payrolls = $dialogParams['payrolls'] || {}

  $ctrl.catalogos = {
    Empleados: Empleados_cache,
    Empresas: $dialogParams['Empresas'],
  }

  $ctrl.cancel = function () {
    dialog.reject()
  }

  $ctrl.select = function () {
    dialog.resolve($ctrl.data)
  }

  $ctrl.calculate = function () {
    if (!$ctrl.data.ID_Nomina) {
      return
    }
    $ctrl.data.Comision_Importe = $ctrl.payrolls[$ctrl.data.ID_Nomina].Comision
    $ctrl.data.Total = $ctrl.data.Comision_Importe * Number($ctrl.data.Comision_Porcentaje)
  }

  $scope.$watch('$ctrl.data.ID_Empresa', function (ID_Empresa) {
    if (ID_Empresa && !$ctrl.catalogos.Empleados[ID_Empresa]) {
      $ctrl.loading = true
      $kardex.$list(ID_Empresa).then(function (kardexes) {
        $ctrl.catalogos.Empleados[ID_Empresa] = kardexes
      }).finally(function () {
        $ctrl.loading = false
      })
    }
  })

  $scope.$watch('$ctrl.data.ID_Empleado', function (ID_Empleado) {
    if (ID_Empleado) {
      $ctrl.data.Empresa = $dialogParams['Catalogos'].Empresas[$ctrl.data.ID_Empresa].Descripcion
      $ctrl.data.Empleado = $ctrl.catalogos.Empleados[$ctrl.data.ID_Empresa][ID_Empleado + '@' + $ctrl.data.ID_Empresa]['Nombre_Completo']
    }
  })
}

module.controller('FinanzasDetallesFacturacionDetalleComisionistasComisionistaController', FinanzasDetallesFacturacionDetalleComisionistasComisionistaController)



// WEBPACK FOOTER //
// ./src/finanzas/_/detallesFacturacion/detalle/comisionistas/comisionista/controller.js